const ToolboxInfo = {
  maxInstances: {
    show_label_text_block: 1,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "show_label_text_block",
            inputs: {
              value: {
                shadow: {
                  type: "text",
                },
              },
            },
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
